
import { PiShieldWarningDuotone } from "react-icons/pi";
import CancelButton from "../../../Components/CommonComponent/Button/CancelButton";
import { useTranslation } from "react-i18next";

export default function RecoverDeleteDataModal({ selectedLedger, handleModalClose, handleRecoverApi}) {
   const { t, } = useTranslation();
  return (
    <div
      className="fixed inset-0 bg-black/20 bg-opacity-40 flex justify-center items-center z-[1000]"
      onClick={handleModalClose}
    >
      <div className="rounded max-w-sm text-start w-full shadow-lg overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="bg-white p-2">
          <div className="bg-theme-bg text-center rounded   mb-2">
            <div className=" font-semibold bg-theme-headerBg rounded-1 text-theme-color py-[2px]">{t('recoverEntry')}</div>
          </div>
          <div className="flex justify-center mb-2">
            <div className="text-[50px] text-theme-createLedgerColor">
              <PiShieldWarningDuotone />
            </div>
          </div>
          <p className="text-gray-700 mb-5 px-2">
           {t('confirmRecover')}"
            <strong className="text-theme-tabHoverColor">
              {selectedLedger?.name || selectedLedger?.groupName || 
                (selectedLedger?.first_name && selectedLedger?.last_name
                  ? `${selectedLedger.first_name} ${selectedLedger.last_name}`
                  : selectedLedger?.first_name || selectedLedger?.last_name
                )
              }
            </strong>
          </p>
          <div className="flex justify-end gap-2">
            <CancelButton onClick={handleModalClose} text={t('cancel')}/>
            <button
              onClick={() => handleRecoverApi(selectedLedger)}
              className="px-2 text-theme-headerBg border-1 border-theme-headerBg hover:bg-theme-headerBg hover:text-theme-color rounded-1  transition-colors"
            >
              {t('recover')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
